import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Отправить новый сигнал на сервер
export const apiSendSignalToServer = async (formData) => {
  try{
    const url = `${backendUrl}/api/signals/`;
    const options = {
      method: 'POST',
      body: formData,
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при создании сигнала: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка создания сигнала отправки жалобы:', error);
    throw error;
  }
};

export const apiSendChangedSignalToServer = async (formData, id) => {
  try{
    const url = `${backendUrl}/api/signals/${id}/`;
    const options = {
      method: 'PATCH',
      body: formData,
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при изменении сигнала: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка изменения сигнала:', error);
    throw error;
  }
}